import Alpine from 'alpinejs'

const SocialLinksForm = (params = {}) => ({
  /**
   * Data
   */
  links: (params.initialLinks || []).map(link => ({
    id: link.id || null,
    platform: link.platform || '',
    url: link.url || '',
    _destroy: false,
    key: crypto.randomUUID()
  })),

  /**
   * Actions
   */
  add() {
    this.links.push({
      id: null,
      platform: '',
      url: '',
      _destroy: false,
      key: crypto.randomUUID()
    })
  },

  remove(index) {
    const link = this.links[index]

    if (link.id) {
      // 已存在資料 → 標記刪除（給 Rails nested attributes）
      link._destroy = true
    } else {
      // 尚未存的 → 直接移除
      this.links.splice(index, 1)
    }
  }
})

Alpine.data('SocialLinksForm', SocialLinksForm)

export default SocialLinksForm
